import styled from 'styled-components';
import { flex } from '../../../../../styles/mixins';

export const Wrapper = styled.div`
    position: absolute;
    ${flex({})}
`;
